import {Redirect, useHistory} from "react-router";
import firebase from "../firebase";
import React from "react";
import { User } from "firebase";
import google_logo from './assets/btn_google_light_normal_ios.svg';
import { Formik, Form, ErrorMessage, Field } from "formik";

const provider = new firebase.auth.GoogleAuthProvider();

interface LoginProps {
  user: User|null;
}

const Login = ({ user }: LoginProps) => {
  const history = useHistory<{ from: { pathname: string } }>();
  const fromPath = history.location.state.from.pathname;
  
  if (user) {
    return <Redirect to={fromPath} />
  }
  return (
    <div className="landing">
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        validate={(values) => {
          const errors: any = {};
          if (!values.email) {
            errors.email = "Required";
          }
          if (!values.password) {
            errors.password = "Required";
          }

          return errors;
        }}
        onSubmit={async (values, actions) => {          
          // login
          await firebase.auth().signInWithEmailAndPassword(values.email, values.password);
          history.push(fromPath);
        }}
      >
        {({ isSubmitting }) => (
          <Form className="profile-form">
            <ErrorMessage className="error" name="email" component="div" />
            <Field type="text" name="email" placeholder="Email" />
            
            <ErrorMessage className="error" name="password" component="div" />
            <Field type="password" name="password" placeholder="Password" />

            <button className="button signup-button" type="submit" disabled={isSubmitting}>
              Login
            </button>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "calc(100% + 2em)", margin: "10px 0" }}>
              <div style={{ height: "1px", width: "100%", backgroundColor: "#aaaaaa" }} />
              <span style={{ margin: "0 8px 3px" }} >or</span>
              <div style={{ height: "1px", width: "100%", backgroundColor: "#aaaaaa" }} />
            </div>
            <div className="google-login-container" onClick={ () => !isSubmitting && firebase.auth().signInWithPopup(provider) }>
                <img src={google_logo} alt="google logo" />
                <span style={{ fontFamily: "Roboto" }}>Login with Google</span>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", width: "calc(100% + 2em)", margin: "40px 0" }}>
              <span>Don't have an account yet?<a href="/signup"> Sign Up</a></span>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
};

export default Login;